import { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { DashboardContext } from '../../../contexts/states/DashboardState';
import { FeedbacksList } from '../../Layouts/dashboard layouts/FeedbacksList';
import { GlobalLoading } from '../../Layouts/GlobalLoading';

export const FeedbacksPage = () => {
  const { feedbacks, initLoading } = useContext(DashboardContext);

  return (
    <div className='main list'>
      <Helmet>
        <title>All Feedbacks | LionTaxi Admin</title>
      </Helmet>
      {initLoading && (
        <div className='background-overlay active'>
          <GlobalLoading />
        </div>
      )}
      <header className='desktop'>
        <h2>Feedbacks</h2>
      </header>
      <div className='feedback-container'>
        {feedbacks.map((feedback) => (
          <FeedbacksList key={feedback._id} feedback={feedback} />
        ))}
      </div>
    </div>
  );
};
